import React, { useEffect, useState } from "react";
import "../../../styles/careers/subheader.scss";
import useClientConfig from "../../../config/careers/clientConfig";
import { useParams } from "react-router-dom";

const CompletionSubHeader = () => {
    
    const { clientConfig, clientSiteSettings } = useClientConfig();    
    const langLabels = clientConfig?.data?.data?.clientSettings?.languageSettings;
    const jobListingLangLabels = langLabels?.jobListing?.[0];
    const [hideJobListingHeaderNav, setHideJobListingHeaderNav] = useState(false);
    const [checkSubMenu, setCheckSubMenu] = useState(false);
    const templateName = clientSiteSettings?.templateName;
    const cliendId = useParams();


    useEffect(() => {

        if (templateName === "template_4" || location.pathname === `/view/${cliendId?.id}/apply-job/from/${cliendId?.from}`) {
            setCheckSubMenu(true);
        }
        setHideJobListingHeaderNav(clientSiteSettings?.showJobListingNav);

        if(clientSiteSettings?.showJobListingNav){
            setCheckSubMenu(clientSiteSettings?.showJobListingNav);
        }

    }, [location, clientConfig]);
    return (
        <>
            { !checkSubMenu  ? 
                <div className={`nav-menu nav-menu-black ${hideJobListingHeaderNav  ? "d-none" : ""}`}>
                    <div id="mt-minus" className="container-fluid">
                        <ul className="nav nav-list pt-3" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link  active" >{jobListingLangLabels?.jobListings}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            : "" }
        </>
    );
};
export default CompletionSubHeader;